<template>
    <div class="restaurant-detail">
        <div class="state-box box" v-if="showTop">
          <img v-if="order.pay_status" class='state-img' src="../assets/images/restaurant_suc_icon.png" alt="">
          <img v-else class='state-img' src="../assets/images/restaurant_err_icon.png"/>
          <div v-if="order.pay_status" class="title">订单完成</div>
          <div v-else class="title">支付失败</div>
          <div class="btn-box">
            <div v-if="false" @click="toComment" class="btn-info">评价</div>
            <div v-if="!order.pay_status" @click='toPay' class="btn-warn">立即支付</div>
          </div>
        </div>
        <div class="detail-box box">
          <div class="info-title"><span></span>{{order.supplier_name}}</div>
          <div class="list" v-for="item in goodsList" :key="item.skuCode" >
            <div class="list-item">
              <div class="data">
                <div>{{item.name}}</div>
                <div>{{item.weight}}克</div>
                <div>¥{{item.gdAmount}}</div>
              </div>
            </div>
            <!-- <view class="list-item">
              <view class="data">
                <view>韭菜鸡蛋</view>
                <view>120克</view>
                <view>¥12.70</view>
              </view>
              <view class="time">
                <view>2021-10-29 17:37:09</view>
                <view>¥12.90</view>
              </view>
            </view> -->
          </div>
          <div class="count">
            <!-- <view>已优惠 ¥2.23</view> -->
            <div>合计 <span>¥{{order.real_pay}}</span></div>
          </div>
        </div>
        <div class="order-box box">
          <div class="order-code">
            <div>托盘编号</div>
            <div>{{order.trayNo}}</div>
          </div>
          <div class="order-log">
            <div>绑定时间<span>{{order.create_time}}</span></div>
            <div v-if="order.payTime">解绑时间<span>{{order.payTime}}</span></div>
            <div>订单编号<span>{{ orderId }}</span></div>
            <div>下单时间<span>{{order.create_time}}</span></div>
            <div v-if="order.payTime">支付时间<span>{{order.payTime}}</span></div>
          </div>
        </div>
    </div>
</template>

<script>
    import {actions} from "../store/actions";

    export default {
        name: "Restaurant",
        data() {
            return {
                showTop: false,
                orderId: '',
                order: {},
                goodsList: [],
            }
        },
        computed: {
            wxUid () {
                return this.$store.state.wxUid
            }
        },
        created() {
            this.order = {
              "order_id": "50210903571000001",
              "supplier_id": 20159,
              "schoolId": "1397",
              "supplier_name": "俺来也智慧餐厅",
              "goods_list": [
                  {"name": "ttt","gdAmount": 0.05,"buyNum": 1,"gdCode": 0,"skuCode": "0","weight": 274}
              ],
              "gift_list": [],
              "amount": 0.05,
              "delivery_fee": 0,
              "package_fee": 0,
              "couponAmount": 0,
              "real_pay": "0.05",
              "order_status": 3001,
              "pay_status": 0,
              "isFinishAfter24H": 0,
              "delivery_time": "2021-09-3 立即就餐",
              "eatIn_time": "2021.09.03 15:51-16:36",
              "address": "",
              "create_time": "2021-09-03 15:51:40",
              "canEstimated": 0,
              "complaint": 2,
              "commercialId": 6980,
              "gift_url": "https://pic.anlaiye.com.cn/82cb2bba001b41be999a716dc4cb12cb_43x43.jpg",
              "gift_activity_name": "满赠优惠",
              "orderType": 4,
              "pickUpCode": "415",
              "refundStatus": 1,
              "supplierTel": "18995638200",
              "comment": "af355d2961c14a2190de0f53e792OA42",
              "showShopRefund": 0,
              "orderShortNumQrCode": {
                "o": "50210903571000001",
                "orderShortNum": "415"
              },
              "qrCodeIndate": "此二维码有效期为 2021.09.03 14:51-17:36",
              "isInvalid": 2,
              "mealStatus": 0,
              "sysCode": 10001,
              "trayNo": "9999",
              "payTime": "2021-09-03 16:15:05"
            }
            this.goodsList = this.order.goods_list;
            this.orderId = this.order.order_id
            this.showTop = true;
        },
        mounted() {
            if(this.$utils.resolveUrl().order_id) {
                this.orderId = this.$utils.resolveUrl().order_id
            } else {
                this.orderId = window.localStorage.getItem('orderCode')
            }
            if (this.$utils.resolveUrl().school_id) {
                actions.postSchoolStatus(this, {school_id: this.$utils.resolveUrl().school_id}, function (data) {
                    let schoolInfo = {
                        schoolId: data.school_id,
                        schoolName: data.school_name
                    }
                    this.$store.commit('changeSchoolInfo', schoolInfo)
                }, function () {
                    this.$messagebox.alert(data.body.message, '')
                })
            }
        },
        methods: {
            getDetail() {
                let params = {
                    token: this.data.token,
                    order_id: this.data.orderId
                }
                actions.youxinOrderList(this, params, (res) => {
                    if (res.result && res.data) {
                        this.order = res.data;
                        this.goodsList = res.data.goods_list ? res.data.goods_list : [];
                        this.showTop = true;
                    } else {
                        this.order = {};
                        this.goodsList = [];
                    }
                })
            },
            toComment() {

            },
            toPay() {

            }
        }
    }
</script>

<style scoped>
.restaurant-detail {
  padding: .3rem;
  width: 100%;
  background: #F8F8F8;
}
.box {
  border-radius: .2rem;
  background: #fff;
  padding: 1rem .3rem .5rem .3rem;
  margin-bottom: .27rem;
}
.state-img {
  display: block;
  margin: 0 auto;
  width: 1.4rem;
  margin-bottom: .5rem;
}
.title {
  font-family: PingFangSC-Semibold;
  font-size: .36rem;
  color: #2F2F2F;
  font-weight: 600;
  text-align: center;
  margin-bottom: .5rem;
}
.btn-box {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.btn-info {
  background: url('../assets/images/restaurant_pay_btn1.png') no-repeat;
  width: 2rem;
  height: .8rem;
  line-height: .8rem;
  background-size: 100% 100%;
  text-align: center
}
.btn-warn {
  background: url('../assets/images/restaurant_btn_bg.png') no-repeat;
  width: 4.8rem;
  height: .72rem;
  line-height: .72rem;
  background-size: 100% 100%;
  text-align: center
}
.detail-box {
  padding: .3rem;
}
.info-title {
  font-family: PingFangSC-Medium;
  font-size: .3rem;
  color: #4A4A4A;
  letter-spacing: 0.12px;
  line-height: .36rem;
  position: relative;
  font-weight: 500;
  padding-left: .3rem;
  margin-bottom: .1rem;
}
.info-title > span {
  contain: "";
  width: .1rem;
  height: .36rem;
  position: absolute;
  left: 0;
  display: block;
  top: 0;
  background: #FFEC00;
}
.list::before {
  content: '';
  display: table;
}
.list-item {
  margin-top: .1rem;
}
.list-item > div {
  display: flex;
  justify-content: space-between;
}
.list-item > div > div {
  line-height: .4rem;
}
.list-item > .data > div:first-of-type {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-item > .time > div {
  font-size: .24rem;
  color: #9E9E9E;
  width: 30%;
}
.list-item > .time > div:last-of-type {
  text-decoration: line-through
}
.count {
  display: flex;
  justify-content: flex-end;
  margin-top: .1rem;
  padding-top: .2rem;
  border-top: .01rem solid #C8C8C8;
}
.count > div {
  font-family: PingFangSC-Medium;
  font-size: .26rem;
  height: .5rem;
  color: #333333;
  margin-left: .2rem;
  display: flex;
  align-items: center;
}
.count > div > span {
  font-size: .36rem;
  color: #FA0223;
  display: block;
  margin-left: .08rem;
}

.order-box {
  padding: .3rem;
  margin-bottom: 0;
}
.order-code {
  display: flex;
  height: 0.6rem;
  justify-content: space-between;
  align-items: center;
  font-family: PingFangSC-Medium;
  font-size: .28rem;
  color: #333333;
  margin-bottom: .3rem;
}
.order-code > div:last-of-type {
  width: 1.6rem;
  height: .6rem;
  line-height: .6rem;
  text-align: center;
  background: url('../assets/images/restaurant_btn3.png') no-repeat;
  background-size: 100% 100%;
}
.order-log {
  padding: 0.32rem 0.16rem 0 0.16rem;
  border-top: 0.5px solid #C8C8C8;
}
.order-log > div {
  color: #797979;
  font-size: 0.28rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  height: 0.6rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.order-log > div > span {
  display: block;
  margin-left: 0.36rem;
  color: #797979;
}

</style>


// WEBPACK FOOTER //
// RestaurantDetail.vue?ae26cb9a